import { createContext, use, useEffect, useState } from 'react';
import { useOfflineSync } from '@/lib/hooks/use-offline-sync';
import { DBCollection } from '@/lib/utils/constants-shared';
import { AppDataContext } from '@/lib/app-data-hydration';
import { DBContext } from '@/lib/context';
import { DataCacheService } from '@/lib/utils/data-cache-service';

type ItemType = TranslationByParagraph;
const collection = DBCollection.translations;

export const TranslationDataContext = createContext<DataContext<ItemType>>(undefined);

export function TranslationDataProvider({ children }) {
    const db = use(DBContext);
    const {data: allData} = use(AppDataContext);
    const {markForSync, resolveSync} = useOfflineSync();
    const [data, setData] = useState<ItemData<ItemType>>();
    const service = new DataCacheService<ItemData<ItemType>>(db, collection, markForSync, resolveSync, data, setData, item => item, []);

    useEffect(() => {
        service.setNewItems(allData?.translations);
    }, [allData?.translations]);

    return <TranslationDataContext value={{
        add: item => service.add(item),
        data,
        get: id => service.get(id),
        remove: id => service.remove(id),
        update: partial => service.update(partial),
        updateAll: items => service.updateAll(items)
    }}>
        {children}
    </TranslationDataContext>;
}